import React, { useContext, useEffect } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Home from "../containers/Home";
import Login from "../containers/Login";
import PrivateRoute from "../HOC/PrivateRoute";

import NotFound from "./../containers/NotFound";
import SettingsListing from "../components/modules/settings/SettingsListing";
import LookupListing from "../components/modules/lookups/LookupListing";
import PagesListing from "../components/modules/pages/PagesListing";
import PageContentUpdate from "../components/modules/pages/PageContentUpdate";
import AdminListing from "../components/modules/admins/AdminListing";
import AdminCreate from "../components/modules/admins/AdminCreate";
import AdminView from "../components/modules/admins/AdminView";
import AdminUpdate from "../components/modules/admins/AdminUpdate";
import AdminChangePassword from "../components/modules/admins/AdminChangePassword";
import ContactUsListing from "../components/modules/contactUs/ContactUsListing";
import ContactUsView from "../components/modules/contactUs/ContactUsView";
import NationalityListing from "../components/modules/nationalities/NationalityListing";
import CountryListing from "../components/modules/countries/CountryListing";
import CountryCreate from "../components/modules/countries/CountryCreate";
import CountryView from "../components/modules/countries/CountryView";
import CountryUpdate from "../components/modules/countries/CountryUpdate";
import PaymentListing from "../components/modules/payments/PaymentListing";
import PaymentView from "../components/modules/payments/PaymentView";
import NationalityCreate from "../components/modules/nationalities/NationalityCreate";
import NationalityUpdate from "../components/modules/nationalities/NationalityUpdate";
import NationalityView from "../components/modules/nationalities/NationalityView";
import TestimonialListing from "../components/modules/testimonial/TestimonialListing";
import TestimonialView from "../components/modules/testimonial/TestimonialView";
import TestimonialUpdate from "../components/modules/testimonial/TestimonialUpdate";
import TestimonialCreate from "../components/modules/testimonial/TestimonialCreate";
import NewsEventsCreate from "../components/modules/newsEvents/NewsEventsCreate";
import NewsEventsListing from "../components/modules/newsEvents/NewsEventsListing";
import NewsEventsView from "../components/modules/newsEvents/NewsEventsView";
import NewsEventsUpdate from "../components/modules/newsEvents/NewsEventsUpdate";
import MediaGalleryListing from "../components/modules/mediaGallery/MediaGalleryListing";
import MediaGalleryView from "../components/modules/mediaGallery/MediaGalleryView";
import MediaGalleryUpdate from "../components/modules/mediaGallery/MediaGalleryUpdate";
import MediaGalleryCreate from "../components/modules/mediaGallery/MediaGalleryCreate";
import MediaGalleryDetails from "../components/modules/mediaGallery/MediaGalleryDetails";
import CartListing from "../components/modules/cart/CartListing";
import CartView from "../components/modules/cart/CartView";
import OrderView from "../components/modules/orders/OrderView";
import OrdersListing from "../components/modules/orders/OrdersListing";
import PageGalleryView from "../components/modules/pageGallery/PageGalleryView";
import PlanListing from "../components/modules/plans/PlanListing";
import PlanCreate from "../components/modules/plans/PlanCreate";
import PlanUpdate from "../components/modules/plans/PlanUpdate";
import MealListing from "../components/modules/meals/MealListing";
import MealCreate from "../components/modules/meals/MealCreate";
import MealUpdate from "../components/modules/meals/MealUpdate";
import ProductListing from "../components/modules/products/ProductListing";
import ProductCreate from "../components/modules/products/ProductCreate";
import ProductUpdate from "../components/modules/products/ProductUpdate";
import ProductView from "../components/modules/products/ProductView";
import HomePageSliderListing from "../components/modules/homePageSlider/HomePageSliderListing";
import HomePageSliderCreate from "../components/modules/homePageSlider/HomePageSliderCreate";
import HomePageSliderUpdate from "../components/modules/homePageSlider/HomePageSliderUpdate";
import SpotLightAreaListing from "../components/modules/spotLightArea/SpotLightAreaListing";
import SpotLightAreaCreate from "../components/modules/spotLightArea/SpotLightAreaCreate";
import SpotLightAreaUpdate from "../components/modules/spotLightArea/SpotLightAreaUpdate";
import BlogPostListing from "../components/modules/recipes/RecipeListing";
import BlogPostCreate from "../components/modules/recipes/RecipeCreate";
import BlogPostUpdate from "../components/modules/recipes/RecipeUpdate";
import BlogPostView from "../components/modules/recipes/RecipeView";
import JobListing from "../components/modules/jobs/JobListing";
import JobView from "../components/modules/jobs/JobView";
import JobCreate from "../components/modules/jobs/JobCreate";
import JobUpdate from "../components/modules/jobs/JobUpdate";
import JobApplicationListing from "../components/modules/jobApplications/JobApplicationListing";
import JobApplicationView from "../components/modules/jobApplications/JobApplicationView";
import PartyRequestListing from "../components/modules/partyRequests/PartyRequestListing";
import PartyRequestView from "../components/modules/partyRequests/PartyRequestView";
import SchoolNurseryRequestListing from "../components/modules/schoolNurseryRequests/SchoolNurseryRequestListing";
import SchoolNurseryRequestView from "../components/modules/schoolNurseryRequests/SchoolNurseryRequestView";
import SubscriptionListing from "../components/modules/subscriptions/SubscriptionListing";
import SubscriptionView from "../components/modules/subscriptions/SubscriptionView";
import CustomerListing from "../components/modules/customers/CustomerListing";
import CustomerView from "../components/modules/customers/CustomerView";
import NotificationsListing from "../components/modules/notifications/NotificationsListing";
import NotificationsCreate from "../components/modules/notifications/NotificationsCreate";
import NotificationsView from "../components/modules/notifications/NotificationsView";
import DiscountCouponListing from "../components/modules/discountCoupons/DiscountCouponListing";
import DiscountCouponCreate from "../components/modules/discountCoupons/DiscountCouponCreate";
import DiscountCouponUpdate from "../components/modules/discountCoupons/DiscountCouponUpdate";
import DiscountCouponView from "../components/modules/discountCoupons/DiscountCouponView";
import RecipeView from "../components/modules/recipes/RecipeView";
import RecipeListing from "../components/modules/recipes/RecipeListing";
import RecipeCreate from "../components/modules/recipes/RecipeCreate";
import RecipeUpdate from "../components/modules/recipes/RecipeUpdate";
import SpecialMealDiscountListing from "../components/modules/specialMealDiscounts/SpecialMealDiscountListing";
import SpecialMealDiscountCreate from "../components/modules/specialMealDiscounts/SpecialMealDiscountCreate";
import SpecialMealDiscountUpdate from "../components/modules/specialMealDiscounts/SpecialMealDiscountUpdate";
import SpecialMealDiscountView from "../components/modules/specialMealDiscounts/SpecialMealDiscountView";
import FoodListing from "../components/modules/food/FoodListing";
import FoodCreate from "../components/modules/food/FoodCreate";
import FoodUpdate from "../components/modules/food/FoodUpdate";
import MenuListing from "../components/modules/menu/MenuListing";
import MenuCreate from "../components/modules/menu/MenuCreate";
import MenuUpdate from "../components/modules/menu/MenuUpdate";
import MenuView from "../components/modules/menu/MenuView";
import ReturnListing from "../components/modules/returns/ReturnListing";
import ReturnView from "../components/modules/returns/ReturnView";
import { AuthContext } from "../contexts/AuthContext";
import FoodView from "../components/modules/food/FoodView";

const ApplicationRoutes = () => {
  useEffect(() => {
    // console.log("ApplicationRoutes");
  }, []);
  const { role } = useContext(AuthContext);
  console.log(role);
  return (
    <div>
      {/* basename="/nodeApp/cms" */}
      <Router>
        <Routes>
          {/* element={userAuthState.isLoggedIn ? <Navigate to="/" /> : <Login />} */}
          <Route exact path="/login" element={<Login />} />
          <Route
            exact
            path="/"
            forceRefresh={true}
            element={
              <PrivateRoute>
                <Home />
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/settings"
            element={
              <PrivateRoute>
                <SettingsListing />
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/lookups"
            element={
              <PrivateRoute>
                <LookupListing />
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/pages"
            element={
              <PrivateRoute>
                <PagesListing />
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/pages/update/:id"
            element={
              <PrivateRoute>
                <PageContentUpdate />
              </PrivateRoute>
            }
          />

          <Route
            exact
            path="/discount-coupons"
            element={
              <PrivateRoute>
                <DiscountCouponListing />
              </PrivateRoute>
            }
          />

          <Route
            exact
            path="/discount-coupons/create"
            element={
              <PrivateRoute>
                <DiscountCouponCreate />
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/discount-coupons/update/:id"
            element={
              <PrivateRoute>
                <DiscountCouponUpdate />
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/discount-coupons/:id"
            element={
              <PrivateRoute>
                <DiscountCouponView />
              </PrivateRoute>
            }
          />

          <Route
            exact
            path="/special-meal-discounts"
            element={
              <PrivateRoute>
                <SpecialMealDiscountListing />
              </PrivateRoute>
            }
          />

          <Route
            exact
            path="/special-meal-discounts/create"
            element={
              <PrivateRoute>
                <SpecialMealDiscountCreate />
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/special-meal-discounts/update/:id"
            element={
              <PrivateRoute>
                <SpecialMealDiscountUpdate />
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/special-meal-discounts/:id"
            element={
              <PrivateRoute>
                <SpecialMealDiscountView />
              </PrivateRoute>
            }
          />

          <Route
            exact
            path="/plans"
            element={
              <PrivateRoute>
                <PlanListing />
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/plans/create"
            element={
              <PrivateRoute>
                <PlanCreate />
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/plans/update/:id"
            element={
              <PrivateRoute>
                <PlanUpdate />
              </PrivateRoute>
            }
          />

          <Route
            exact
            path="/meals"
            element={
              <PrivateRoute>
                <MealListing />
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/meals/create"
            element={
              <PrivateRoute>
                <MealCreate />
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/meals/update/:id"
            element={
              <PrivateRoute>
                <MealUpdate />
              </PrivateRoute>
            }
          />

          <Route
            exact
            path="/foods"
            element={
              <PrivateRoute>
                <FoodListing />
              </PrivateRoute>
            }
          />

          <Route
            exact
            path="/foods/:id"
            element={
              <PrivateRoute>
                <FoodView />
              </PrivateRoute>
            }
          />

          <Route
            exact
            path="/foods/create"
            element={
              <PrivateRoute>
                <FoodCreate />
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/foods/update/:id"
            element={
              <PrivateRoute>
                <FoodUpdate />
              </PrivateRoute>
            }
          />

          <Route
            exact
            path="/menu"
            element={
              <PrivateRoute>
                <MenuListing />
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/menu/create"
            element={
              <PrivateRoute>
                <MenuCreate />
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/menu/update/:meal/:id"
            element={
              <PrivateRoute>
                <MenuUpdate />
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/menu/:id"
            element={
              <PrivateRoute>
                <MenuView />
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/products"
            element={
              <PrivateRoute>
                <ProductListing />
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/products/:id"
            element={
              <PrivateRoute>
                <ProductView />
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/products/create"
            element={
              <PrivateRoute>
                <ProductCreate />
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/products/update/:id"
            element={
              <PrivateRoute>
                <ProductUpdate />
              </PrivateRoute>
            }
          />

          <Route
            exact
            path="/job-applications"
            element={
              <PrivateRoute>
                <JobApplicationListing />
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/job-applications/:id"
            element={
              <PrivateRoute>
                <JobApplicationView />
              </PrivateRoute>
            }
          />

          <Route
            exact
            path="/jobs"
            element={
              <PrivateRoute>
                <JobListing />
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/jobs/:id"
            element={
              <PrivateRoute>
                <JobView />
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/jobs/create"
            element={
              <PrivateRoute>
                <JobCreate />
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/jobs/update/:id"
            element={
              <PrivateRoute>
                <JobUpdate />
              </PrivateRoute>
            }
          />

          {/* // {userAuthState.user &&
            (userAuthState.user.role === "Admin" ||
              userAuthState.user.role === "Club President" ||
              userAuthState.user.role === "Club Vice President") && (
              <> */}
          {role?.toLowerCase() === "admin" && (
            <>
              <Route
                exact
                path="/notifications"
                element={
                  <PrivateRoute>
                    <NotificationsListing />
                  </PrivateRoute>
                }
              />
              <Route
                exact
                path="/notifications/create"
                element={
                  <PrivateRoute>
                    <NotificationsCreate />
                  </PrivateRoute>
                }
              />
              <Route
                exact
                path="/notifications/:id"
                element={
                  <PrivateRoute>
                    <NotificationsView />
                  </PrivateRoute>
                }
              />
            </>
          )}
          {/*  </> )} */}
          {role?.toLowerCase() === "admin" && (
            <>
              <Route
                exact
                path="/admins"
                element={
                  <PrivateRoute>
                    <AdminListing />
                  </PrivateRoute>
                }
              />
              <Route
                exact
                path="/admins/create"
                element={
                  <PrivateRoute>
                    <AdminCreate />
                  </PrivateRoute>
                }
              />
              <Route
                exact
                path="/admins/:id"
                element={
                  <PrivateRoute>
                    <AdminView />
                  </PrivateRoute>
                }
              />
              <Route
                exact
                path="/admins/update/:id"
                element={
                  <PrivateRoute>
                    <AdminUpdate />
                  </PrivateRoute>
                }
              />
              <Route
                exact
                path="/admins/change-password/:id"
                element={
                  <PrivateRoute>
                    <AdminChangePassword />
                  </PrivateRoute>
                }
              />
            </>
          )}
          <Route
            exact
            path="/contact-us"
            element={
              <PrivateRoute>
                <ContactUsListing />
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/contact-us/:id"
            element={
              <PrivateRoute>
                <ContactUsView />
              </PrivateRoute>
            }
          />

          <Route
            exact
            path="/nationalities"
            element={
              <PrivateRoute>
                <NationalityListing />
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/nationalities/create"
            element={
              <PrivateRoute>
                <NationalityCreate />
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/nationalities/:id"
            element={
              <PrivateRoute>
                <NationalityView />
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/nationalities/update/:id"
            element={
              <PrivateRoute>
                <NationalityUpdate />
              </PrivateRoute>
            }
          />

          <Route
            exact
            path="/countries"
            element={
              <PrivateRoute>
                <CountryListing />
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/countries/create"
            element={
              <PrivateRoute>
                <CountryCreate />
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/countries/:id"
            element={
              <PrivateRoute>
                <CountryView />
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/countries/update/:id"
            element={
              <PrivateRoute>
                <CountryUpdate />
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/page-gallery/:id"
            element={
              <PrivateRoute>
                <PageGalleryView />
              </PrivateRoute>
            }
          />

          <Route
            exact
            path="/home-page-sliders"
            element={
              <PrivateRoute>
                <HomePageSliderListing />
              </PrivateRoute>
            }
          />

          <Route
            exact
            path="/home-page-sliders/create"
            element={
              <PrivateRoute>
                <HomePageSliderCreate />
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/home-page-sliders/update/:id"
            element={
              <PrivateRoute>
                <HomePageSliderUpdate />
              </PrivateRoute>
            }
          />

          <Route
            exact
            path="/spot-light-areas"
            element={
              <PrivateRoute>
                <SpotLightAreaListing />
              </PrivateRoute>
            }
          />

          <Route
            exact
            path="/spot-light-areas/create"
            element={
              <PrivateRoute>
                <SpotLightAreaCreate />
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/spot-light-areas/update/:id"
            element={
              <PrivateRoute>
                <SpotLightAreaUpdate />
              </PrivateRoute>
            }
          />

          <Route
            exact
            path="/news-events"
            element={
              <PrivateRoute>
                <NewsEventsListing />
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/news-events/:id"
            element={
              <PrivateRoute>
                <NewsEventsView />
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/news-events/create"
            element={
              <PrivateRoute>
                <NewsEventsCreate />
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/news-events/update/:id"
            element={
              <PrivateRoute>
                <NewsEventsUpdate />
              </PrivateRoute>
            }
          />

          <Route
            exact
            path="/recipes"
            element={
              <PrivateRoute>
                <RecipeListing />
              </PrivateRoute>
            }
          />

          <Route
            exact
            path="/recipes/:id"
            element={
              <PrivateRoute>
                <RecipeView />
              </PrivateRoute>
            }
          />

          <Route
            exact
            path="/recipes/create"
            element={
              <PrivateRoute>
                <RecipeCreate />
              </PrivateRoute>
            }
          />

          <Route
            exact
            path="/recipes/update/:id"
            element={
              <PrivateRoute>
                <RecipeUpdate />
              </PrivateRoute>
            }
          />

          <Route
            exact
            path="/party-requests"
            element={
              <PrivateRoute>
                <PartyRequestListing />
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/party-requests/:id"
            element={
              <PrivateRoute>
                <PartyRequestView />
              </PrivateRoute>
            }
          />

          <Route
            exact
            path="/school-nursery-requests"
            element={
              <PrivateRoute>
                <SchoolNurseryRequestListing />
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/school-nursery-requests/:id"
            element={
              <PrivateRoute>
                <SchoolNurseryRequestView />
              </PrivateRoute>
            }
          />
          {role?.toLowerCase() === "admin" && (
            <>
              <Route
                exact
                path="/subscriptions"
                element={
                  <PrivateRoute>
                    <SubscriptionListing />
                  </PrivateRoute>
                }
              />
              <Route
                exact
                path="/subscriptions/:id"
                element={
                  <PrivateRoute>
                    <SubscriptionView />
                  </PrivateRoute>
                }
              />
            </>
          )}
          <Route
            exact
            path="/media-gallery-albums"
            element={
              <PrivateRoute>
                <MediaGalleryListing />
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/media-gallery-albums/create"
            element={
              <PrivateRoute>
                <MediaGalleryCreate />
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/media-gallery-albums/:id"
            element={
              <PrivateRoute>
                <MediaGalleryView />
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/media-gallery-albums/update/:id"
            element={
              <PrivateRoute>
                <MediaGalleryUpdate />
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/media-gallery-albums/picture-details/:id"
            element={
              <PrivateRoute>
                <MediaGalleryDetails />
              </PrivateRoute>
            }
          />
          {/* <Route exact path="/gallery-picture-comments/:id" element={<PrivateRoute><GalleryPictureCommentsListing /></PrivateRoute>} />
                    <Route exact path="/gallery-picture-likes/:id" element={<PrivateRoute><GalleryPictureLikesListing /></PrivateRoute>} />  */}
          {role?.toLowerCase() === "admin" && (
            <>
              <Route
                exact
                path="/customers"
                element={
                  <PrivateRoute>
                    <CustomerListing />
                  </PrivateRoute>
                }
              />
              <Route
                exact
                path="/customers/:id"
                element={
                  <PrivateRoute>
                    <CustomerView />
                  </PrivateRoute>
                }
              />
            </>
          )}
          {role?.toLowerCase() === "admin" && (
            <>
              <Route
                exact
                path="/carts"
                element={
                  <PrivateRoute>
                    <CartListing />
                  </PrivateRoute>
                }
              />
              <Route
                exact
                path="/carts/:id"
                element={
                  <PrivateRoute>
                    <CartView />
                  </PrivateRoute>
                }
              />
            </>
          )}
          {role?.toLowerCase() === "admin" && (
            <>
              <Route
                exact
                path="/orders"
                element={
                  <PrivateRoute>
                    <OrdersListing />
                  </PrivateRoute>
                }
              />
              <Route
                exact
                path="/orders/:id"
                element={
                  <PrivateRoute>
                    <OrderView />
                  </PrivateRoute>
                }
              />
            </>
          )}
          <Route
            exact
            path="/returns"
            element={
              <PrivateRoute>
                <ReturnListing />
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/returns/:id"
            element={
              <PrivateRoute>
                <ReturnView />
              </PrivateRoute>
            }
          />
          {role?.toLowerCase() === "admin" && (
            <>
              <Route
                exact
                path="/payments"
                element={
                  <PrivateRoute>
                    <PaymentListing />
                  </PrivateRoute>
                }
              />
              <Route
                exact
                path="/payments/:id"
                element={
                  <PrivateRoute>
                    <PaymentView />
                  </PrivateRoute>
                }
              />
            </>
          )}
          <Route
            exact
            path="/testimonials"
            element={
              <PrivateRoute>
                <TestimonialListing />
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/testimonials/:id"
            element={
              <PrivateRoute>
                <TestimonialView />
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/testimonials/create"
            element={
              <PrivateRoute>
                <TestimonialCreate />
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/testimonials/update/:id"
            element={
              <PrivateRoute>
                <TestimonialUpdate />
              </PrivateRoute>
            }
          />

          <Route path="*" element={<NotFound />} />
        </Routes>
      </Router>
    </div>
  );
};

export default ApplicationRoutes;
